import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum TribalAffiliationEnum {
    USFederallyRecognizedTribe = "1",
    NativeEntityintheContiguousUS = "2",
    NativeEntityinAlaska = "3",
    Unknown = "4",
    Other = "5"
}
export class TribalAffiliationClass extends EnumWithDescription<TribalAffiliationEnum> {
    public readonly enum = TribalAffiliationEnum;
    public readonly enumName: string = "TribalAffiliation";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<TribalAffiliationEnum>> = new Map([
        [
            "USFederallyRecognizedTribe",
            {
                value: TribalAffiliationEnum.USFederallyRecognizedTribe,
                name: "U.S.Federally Recognized Tribe"
            }
        ],
        [
            "NativeEntityintheContiguousUS",
            {
                value: TribalAffiliationEnum.NativeEntityintheContiguousUS,
                name: "Native Entity in the Contiguous U.S."
            }
        ],
        [
            "NativeEntityinAlaska",
            {
                value: TribalAffiliationEnum.NativeEntityinAlaska,
                name: "Native Entity in Alaska"
            }
        ],
        [
            "Unknown",
            {
                value: TribalAffiliationEnum.Unknown,
                name: "Unknown"
            }
        ],
        [
            "Other",
            {
                value: TribalAffiliationEnum.Other,
                name: "Other"
            }
        ]
    ]);
}

export const TribalAffiliation = new TribalAffiliationClass();
